export default {
  CreateOrder: 'CreateOrder',
  OrderType: 'OrderType',
  Recipient: 'Recipient',
  CancelOrder: 'CancelOrder',
  ShippingMethod: 'ShippingMethod',
  PaymentMethod: 'PaymentMethod',
  PackingInstructions: 'PackingInstructions',
  AddProducts: 'AddProducts',
  ShippingInformation: 'ShippingInformation',
  ReviewOrder: 'ReviewOrder'
}

